import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

const ArticleCanonical = ({ url }) => {
  useEffect(() => {
    document.querySelector('[rel="canonical"]') && document.querySelector('[rel="canonical"]').remove();
  },[]);

  return (
    <Helmet>
      <link rel="canonical" href={url} />
    </Helmet>
  );
};

export default ArticleCanonical;